import { useState, useEffect } from "react";

const WebinarTimeLeft = ({ details }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  // Move target date calculation outside useEffect
  const getTargetDate = () => {
    const targetDate = new Date(details?.date);

    targetDate.setDate(targetDate.getDate()); // Change this number to adjust days
    targetDate.setHours(16, 0, 0, 0); // 4:00 PM - Change time here
    return targetDate;
  };

  useEffect(() => {
    if (!details?.date) return;
    const targetDate = getTargetDate();
    // console.log("Target Date:", targetDate);
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const target = targetDate.getTime();
      const difference = target - now;

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (difference % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [details?.date]); // Empty dependency array is fine now

  const TimeUnit = ({ value, label }) => (
    <div className="flex flex-col items-center">
      <div className="text-xs font-semibold mb-2 uppercase tracking-widest bg-gradient-to-r from-blue-400 via-blue-500 to-indigo-600 bg-clip-text text-transparent">
        {label}
      </div>
      <div className="relative group">
        {/* Animated border gradient */}
        <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-600 via-purple-600 to-blue-800 rounded-lg opacity-75 group-hover:opacity-100 blur-sm transition duration-300 animate-pulse"></div>

        {/* Main counter box */}
        <div className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-black border border-slate-600 rounded-lg px-4 py-3 min-w-[60px] flex items-center justify-center backdrop-blur-sm">
          <span className="text-2xl font-bold text-white tabular-nums relative z-10 drop-shadow-lg">
            {value.toString().padStart(2, "0")}
          </span>

          {/* Inner glow effect */}
          <div className="absolute inset-0 bg-gradient-to-t from-blue-900/20 to-transparent rounded-lg pointer-events-none"></div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="relative max-w-md mx-auto p-2 md:p-0">
      {/* Outer glow border */}
      <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 via-purple-600 to-blue-800 rounded-xl opacity-30 blur-lg"></div>

      {/* Main card */}
      <div className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-black rounded-xl p-6 shadow-2xl border border-slate-700/50 backdrop-blur-sm">
        {/* Subtle inner border glow */}
        <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-blue-500/10 via-purple-500/5 to-blue-500/10 pointer-events-none"></div>

        <div className="relative z-10">
          <h2 className="text-white text-lg font-semibold text-center mb-6 drop-shadow-md">
            Your Webinar is in
            <div className="w-16 h-0.5 bg-gradient-to-r from-blue-500 to-purple-600 mx-auto mt-2 rounded-full"></div>
          </h2>

          <div className="flex justify-center gap-4">
            <TimeUnit value={timeLeft.days} label="Days" />
            <TimeUnit value={timeLeft.hours} label="Hours" />
            <TimeUnit value={timeLeft.minutes} label="Minutes" />
            <TimeUnit value={timeLeft.seconds} label="Seconds" />
          </div>
        </div>

        {/* Background decoration */}
      </div>
    </div>
  );
};

export default WebinarTimeLeft;
